import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  Font
} from "@react-pdf/renderer";
import reshaper from "arabic-persian-reshaper";

Font.register({
  family: "IRANYekan",
    src: "/fonts/IRANYekanFN-Medium.ttf"
  // src: "../../../assets/fonts/IRANYekanFN-Medium.ttf"
});
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontFamily: "IRANYekan",
    direction: "rtl",
    fontSize: 12
  },
  title: {
    fontSize: 16,
    marginBottom: 20,
    textAlign: "right"
  },
  qa: {
    marginBottom: 10
  },
  question: {
    fontWeight: "bold",
    textAlign: "right"
  },
  answer: {
    textAlign: "right"
  },
  signature: {
    marginTop: 40,
    width: 150,
    height: 100,
    alignSelf: "flex-end" // 🔥 RTL image alignment
  }
});
// const rtl = (text = "") => reshape(text);
const rtl = (text = "") =>
  reshaper.PersianShaper.convertArabic(String(text));
const AnswerPdf = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page}>

      <Text style={styles.title}>
        {rtl("فرم گزینش")}
      </Text>

      {data?.question.map((item, index) => (
        <View key={index} style={styles.qa}>
          <Text style={styles.question}>
            {rtl(`سوال ${index + 1}: ${item.question}`)}
          </Text>
          <Text style={styles.answer}>
            {rtl(`جواب: ${item.answer || "—"}`)}
          </Text>
        </View>
      ))}

      <Text style={{ marginTop: 30, textAlign: "right" }}>
        {rtl(`نام: ${data.user}`)}
      </Text>

      {data.signature && (
        <Image
          src={data.signature}
          style={styles.signature}
        />
      )}

    </Page>
  </Document>
);


export default AnswerPdf;
